import { updateCompany } from 'frontend/src/components/API';
import { setUserAttribute, getUrlSignUpParams, is8DataApp, logger } from '.';
import { connectShopifyShopToCompany } from '../components/API/shopify';
import { AdCampaign } from '../Types';

export const URL_PARAMS_ON_SIGNUP = 'url_params_on_sign_up';
export const SHOPIFY_SIGNUP = 'shopify_signup';

export enum SignUpType {
  MANUAL = 'manual',
  GOOGLE = 'google',
}

export function setShopifyParams(query: URLSearchParams) {
  const shop = query.get('shop');
  const timestamp = query.get('timestamp');
  const hmac = query.get('hmac');
  if (shop && timestamp && hmac) {
    localStorage.setItem(
      SHOPIFY_SIGNUP,
      JSON.stringify({
        shop,
        timestamp,
        hmac,
      }),
    );
  }
}

export type ShopifyParams = {
  shop: string;
  timestamp: string;
  hmac: string;
};

export function getShopifyParams(): ShopifyParams | null {
  const shopifyData = localStorage.getItem(SHOPIFY_SIGNUP);
  return shopifyData && JSON.parse(shopifyData);
}

export async function updateCompanyWithSignUpData(
  urlParams: Record<string, unknown>,
) {
  try {
    const updates = {};
    const influencerName = localStorage.getItem('influencer');
    const referralEmail = localStorage.getItem('referral');
    if (influencerName) {
      updates['influencerName'] = influencerName;
    }
    if (referralEmail) {
      updates['referralEmail'] = referralEmail;
    }
    if (Object.keys(urlParams)?.length > 0) {
      updates['url_params_on_signup'] = JSON.stringify(urlParams);
    }
    await updateCompany(updates);
    localStorage.removeItem(URL_PARAMS_ON_SIGNUP);
  } catch (error) {
    // FAIL SILENTLY.
  }
}

export async function updateShopifyShopWithCompany() {
  try {
    if (is8DataApp()) {
      const shopifyData = getShopifyParams();
      if (shopifyData) {
        await connectShopifyShopToCompany(shopifyData);
      }
    }
  } catch (error) {
    logger.error({ message: `failed to update shop with comapny`, error });
  }
}

export async function saveSignUpData() {
  try {
    const urlParams = await getUrlSignUpParams();
    updateCompanyWithSignUpData(urlParams);
    if (Object.keys(urlParams)?.length > 0) {
      setUserAttribute(
        'custom:url_params_on_signup',
        JSON.stringify(urlParams),
      );
    }
  } catch (error) {
    // FAIL SILENTLY
    logger.error({ message: `failed to save signup data`, error });
  }
}

export function setUrlSignUpParamsInLocalStorage() {
  const params = new URLSearchParams(window.location.search);
  localStorage.setItem(URL_PARAMS_ON_SIGNUP, params.toString());
}

export async function getAdCampaign() {
  const params = await getUrlSignUpParams();
  let adCampaign = null;
  if (params?.utc_source === 'facebook') {
    adCampaign = AdCampaign.facebook;
  }
  if (params?.marketing_source === 'googlesearch') {
    adCampaign = AdCampaign.google;
  }
  return adCampaign;
}

export async function trackSignUp(
  firstName: string,
  lastName: string,
  email: string,
  userId: string,
  type: SignUpType,
  trackEvent: (event: Record<string, unknown>) => void,
) {
  const adCampaign = await getAdCampaign();
  trackEvent({
    event: 'sign_up',
    sign_up_type: type,
    user: email,
    first_name: firstName,
    last_name: lastName,
    id: userId,
    ad_campaign: adCampaign,
  });
}
